module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-content-inner"
  }, [_c('h2', {
    staticClass: "main-headline"
  }, [_vm._v("YOUR PROJECT. YOUR VISION.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "products-selection-subtitle"
  }, [_vm._v("Click on a product for more information")]), _vm._v(" "), _c('ul', {
    staticClass: "products-selection-list"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/bricks"
    }
  }, [_c('img', {
    attrs: {
      "width": "144",
      "height": "144",
      "src": "images/Products-Page/products4.png",
      "alt": "Bricks"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "product-icon",
    attrs: {
      "to": "/bricks"
    }
  }, [_vm._v("Bricks")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/tiles"
    }
  }, [_c('img', {
    attrs: {
      "width": "144",
      "height": "144",
      "src": "images/Products-Page/products5.png",
      "alt": "Tiles"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "product-icon",
    attrs: {
      "to": "/tiles"
    }
  }, [_vm._v("Tiles")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/fonts"
    }
  }, [_c('img', {
    attrs: {
      "height": "90",
      "width": "90",
      "src": "images/Products-Page/products6.png",
      "alt": "Fonts"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "product-icon",
    attrs: {
      "to": "/fonts"
    }
  }, [_vm._v("Fonts")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/symbols"
    }
  }, [_c('img', {
    attrs: {
      "height": "80",
      "width": "80",
      "src": "images/Products-Page/products7.png",
      "alt": "Symbols"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "product-icon",
    attrs: {
      "to": "/symbols"
    }
  }, [_vm._v("Symbols")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "subheadline"
  }, [_vm._v("Fund Raisers, Ltd. has the products you need to reach the goals you want! We know"), _c('br'), _vm._v("\n            too many options are overwhelming, so we have refined our product selection to "), _c('br'), _vm._v("\n            ensure your project is successful.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "products-benefits-list"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": "images/Products-Page/products1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "products-benefits-headline"
  }, [_vm._v("HAND SELECTED")]), _vm._v(" "), _c('span', {
    staticClass: "products-benefits-text"
  }, [_vm._v("With 30+ years of experience,\n                we know what works.")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "images/Products-Page/products2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "products-benefits-headline"
  }, [_vm._v("TOP SELLER")]), _vm._v(" "), _c('span', {
    staticClass: "products-benefits-text"
  }, [_vm._v("Featured in thousands of projects in all 50 states.")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "images/Products-Page/products3.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "products-benefits-headline"
  }, [_vm._v("QUALITY")]), _vm._v(" "), _c('span', {
    staticClass: "products-benefits-text"
  }, [_vm._v("We only use the best in the industry.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', {
    staticClass: "products-selection-title"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('span', [_vm._v("PRODUCT SELECTION")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4723f76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products.vue
// module id = Rwln
// module chunks = 1